// extracted by mini-css-extract-plugin
export var container = "_bt-1";
export var cornerButtonContainer = "_bt-5";
export var disabled = "_bt-2";
export var fileContainer = "_bt-4";
export var hiddenInput = "_bt-3";
export var widthContainer = "_bt-0";